module.exports = __webpack_public_path__ + "img/btn_blue.60cafb6b.png";